import { pipe, find, propEq, concat, prop } from 'ramda'
import { TRACKING_OFFER_TYPES } from 'src/features/tracking/duck/consts'
import {
  CUSTOMS_CLEARANCE_TYPE_OPTIONS_EXPORT,
  CUSTOMS_CLEARANCE_TYPE_OPTIONS_IMPORT
} from 'src/features/orders/duck/consts'

const CUSTOMS_CLEARANCE_TYPE_OPTIONS = concat(
  CUSTOMS_CLEARANCE_TYPE_OPTIONS_IMPORT,
  CUSTOMS_CLEARANCE_TYPE_OPTIONS_EXPORT
)

export const isGeneralOrder = order => {
  const offerType = order?.offerType || order?.offer?.offerContextType

  return offerType === TRACKING_OFFER_TYPES.GENERAL
}

export const getOrderLocationSummary = order => {
  if (isGeneralOrder(order)) {
    return {
      address: [order.loadingAddress, order.unloadingAddress]
        .filter(Boolean)
        .join(' → '),
      dateTime: [order.loadingDateTime, order.unloadingDateTime]
        .filter(Boolean)
        .join(' → ')
    }
  }

  return {
    address: order.loadingUnloadingAddress,
    dateTime: order.loadingUnloadingDateTime
  }
}

export const getOrderCargoSummary = order =>
  [
    order.container?.name,
    order.shipowner?.name ||
      order.cargoType?.name ||
      order.offer?.cargoType?.name
  ]
    .filter(Boolean)
    .join(', ')

const normalizeCustomsClearanceTypes = customsClearanceTypes => {
  if (Array.isArray(customsClearanceTypes)) {
    return customsClearanceTypes.map(item => item?.value || item)
  }

  if (customsClearanceTypes && typeof customsClearanceTypes === 'object') {
    return Object.keys(customsClearanceTypes)
  }

  return []
}

export const getCustomsClearanceTypeOptions = customsClearanceTypes =>
  normalizeCustomsClearanceTypes(customsClearanceTypes)
    .map(value => find(propEq('value', value), CUSTOMS_CLEARANCE_TYPE_OPTIONS))
    .filter(Boolean)

/**
 * Returns order issuer/contractor instead of forwarder/carrier
 * @param {{forwarderUser, carrierUser, offer: {offerContextType}}} orderDetails
 * @returns {{contractor, issuer}}
 */
export const getIssuerAndContractorFromOrderDetails = orderDetails => {
  if (!orderDetails) return

  const issuer = {
    [TRACKING_OFFER_TYPES.EXPORT]: orderDetails.forwarderUser,
    [TRACKING_OFFER_TYPES.IMPORT]: orderDetails.forwarderUser,
    [TRACKING_OFFER_TYPES.GENERAL]: orderDetails.forwarderUser,
    [TRACKING_OFFER_TYPES.FREE_CARRIER]: orderDetails.forwarderUser,
    [TRACKING_OFFER_TYPES.POST_IMPORT]: orderDetails.forwarderUser
  }[orderDetails.offer.offerContextType]

  const contractor = {
    [TRACKING_OFFER_TYPES.EXPORT]: orderDetails.carrierUser,
    [TRACKING_OFFER_TYPES.IMPORT]: orderDetails.carrierUser,
    [TRACKING_OFFER_TYPES.GENERAL]: orderDetails.carrierUser,
    [TRACKING_OFFER_TYPES.FREE_CARRIER]: orderDetails.carrierUser,
    [TRACKING_OFFER_TYPES.POST_IMPORT]: orderDetails.carrierUser
  }[orderDetails.offer.offerContextType]

  return {
    issuer,
    contractor
  }
}

export const translateCustomsClearanceType = customsClearanceType =>
  pipe(
    find(propEq('value', customsClearanceType)),
    prop('label')
  )(CUSTOMS_CLEARANCE_TYPE_OPTIONS)
